import { MenuItems } from "@/src/types";
import React, { useContext, useEffect, useState } from "react";
import Nav from "../Nav";
import Footer from "./Footer";
import { HIDE_SHOP } from "@/src/constants";

import { AuthContext } from "@/pages/_app";

export interface LayoutProps {
  menus: MenuItems;
  children: any;
}

const Layout = ({ menus, children }: LayoutProps) => {
  const { authContext } = useContext(AuthContext);

  return (
    <div>
      {/* h-[3rem] reserves room for the cart icon; not needed without it. */}
      <div className={HIDE_SHOP ? "nav" : "nav h-[3rem]"}>
        <Nav menuProps={menus} loggedIn={authContext?.isLoggedIn ?? false} />
      </div>
      {children}
      <Footer />
    </div>
  );
};

export default Layout;
